import { getCategories } from 'modules/aboutIsnPage/aboutIsn.api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { getLanguage, getQueryString } from 'utils/params';
import { BannerAbout, BreadcrumbAboutIsn, HousingMaterialMenu, MaterialOverviewContent } from '../../common';
const MaterialOverviewComponent = () => {
    const { t } = useTranslation();
    const language = getLanguage(useLocation());
    const [banner, setBanner] = useState({});

    const breadCrumb = [
        { title: t('about_isn.home'), url: '/' },
        { title: t('about_isn.about_us'), url: '/about-us' },
        { title: t('about_isn.housing_materials'), url: '/about-us/housing-material/overview' },
        { title: t('about_isn.housing_material.lbl_overview') },
    ];
    useEffect(() => {
        getCategories(getQueryString({language})).then(res => {
            if(res?.data){
              let banner = res?.data.filter(el => {return el.id === 3});
              if(banner){
                setBanner({
                  img: `${process.env.REACT_APP_ISN_IMAGE_URL}${banner[0].imageUrl}`,
                  title: t('about_isn.housing_materials')
                });
              }
            }
          })
          window.scrollTo({top: 0, behavior: 'smooth'});
        //eslint-disable-next-line
    }, [language])
    return (
        <>
            <div id="position-scroll"></div>
            <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
            <section className="profile-company group-company">
                <BannerAbout banner={banner} />
                <HousingMaterialMenu/>
                <div className="container">
                    <MaterialOverviewContent />
                </div>
            </section>
        </>
    )
}
export default MaterialOverviewComponent;
